/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const authenticatedNavigationStyle = {
  authenticatedNavigation: {
    height: "100%",
    overflow: "hidden",
  },
  caseList: {
    marginTop: "2rem",
    paddingLeft: "0.25rem",
    overflow: "hidden",
    flexGrow: 1,
    minHeight: 0,
  },
  inquiryIcon: {
    marginLeft: "auto",
    paddingLeft: "0.5rem",
    display: "inline-block",
    lineHeight: 1,
  },
  link: {
    padding: "0.5rem",
    borderRadius: "0.25rem",
  },
  linkActive: (theme: Theme) => ({
    backgroundColor: theme.palette.primaryPale,
    "&:hover": {
      backgroundColor: theme.palette.primaryPale,
    },
  }),
};
